/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';
import {
    getPrevLevelComment,
    getReactionBar,
    renderComments,
    renderExpandedCommentList,
} from '../../../pages/Community/utils';
import CommonCard from '../../Content/CommonCard/CommonCard';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import CommentInput from '../CommentInput/CommentInput';
import DeletedPost from '../DeletedPost/DeletedPost';
import DiscussionComponent from '../DiscussionComponent/DiscussionComponent';
import EditorialCard from '../EditorialCard/EditorialCard';
import EditorialPodcastSectionForSingleContent from '../EditorialPodcastSectionForSingleContent/EditorialPodcastSectionForSingleContent';
import UnifiedPostCard from '../../UnifiedPostCard/UnifiedPostCard';
import { PAGE_PROPS } from '../../../pages/defaultProps';
import { constructCn } from '../../../utilities/helperFunctions';

import { CommunityContext } from '../../../contexts/ContextCreator';

import './SingleCommunityContentSection.scss';

/**
 * @deprecated, will be replaced by <CommunityContentDisplay/> and <CommunityCommentsDisplay/>
 */
export class SingleCommunityContentSection extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            commentToShow: null,
        };
    }

    componentDidMount() {
        if (
            this.props.PAGE_PROPS &&
            this.props.PAGE_PROPS.url &&
            this.props.PAGE_PROPS.url &&
            this.props.PAGE_PROPS.url.original.includes('?') &&
            !this.props.isPreview
        ) {
            const currentCommentHash = this.props.PAGE_PROPS.url.original.split(
                '?'
            )[1];
            const commentToShow = this.props.refs[currentCommentHash];
            this.setState({
                commentToShow,
            });
        }
    }

    getShowUnifiedPostCard = (content) =>
        this.context?.pageProps?.featureFlags?.unifiedPostBox &&
        (content.type === 'community-discussion' ||
            content.type === 'community-link' ||
            content.type === 'community-photo');

    renderExpandedCommentList = (content) => {
        const PrevLevelCommentHash =
            this.state.commentToShow &&
            getPrevLevelComment(this.props.refs, this.state.commentToShow.hash);
        const PrevLevelComment = this.props.refs[PrevLevelCommentHash];
        const isFirstLevelComments =
            PrevLevelComment && PrevLevelComment.parentType
                ? !!(PrevLevelComment.parentType !== 'community-comment')
                : true;
        const showUnifiedPostCard = this.getShowUnifiedPostCard(content);
        let ExpandedCommentList = renderExpandedCommentList(
            content.title,
            this.state.commentToShow,
            this.setComment,
            this.BackToPrevCommentFunction,
            isFirstLevelComments
        );

        if (showUnifiedPostCard) {
            ExpandedCommentList = (
                <div className="comment-list-padding-wrapper">
                    {ExpandedCommentList}
                </div>
            );
        }

        return ExpandedCommentList;
    };

    renderMainContent = (content) => {
        const contentToShow =
            content.type === 'editorial-content' ||
            content.type === 'community-podcast'
                ? this.renderEditorial(content)
                : this.renderSingleContent(content);

        return this.state.commentToShow
            ? this.renderExpandedCommentList(content)
            : contentToShow;
    };

    renderEditorial = (content) => {
        return (
            <React.Fragment>
                <EditorialPodcastSectionForSingleContent
                    currentTopic={this.props.currentTopic}
                    content={content}
                    showReactionBar={!this.props.hideReactionBar}
                />
                {this.renderCommentSection(content)}
            </React.Fragment>
        );
    };

    renderSingleContent = (content) => {
        const showUnifiedPostCard = this.getShowUnifiedPostCard(content);
        const singleContentReactionBar = showUnifiedPostCard
            ? getReactionBar(
                  `${content.type}-bottom-comment-input`,
                  true,
                  content.hash
              )
            : null;

        return (
            <React.Fragment>
                <UnifiedPostCard
                    {...content}
                    className="single-content-postcard"
                    isSingleContent
                    singleContentReactionBar={singleContentReactionBar}
                    location="singleContent"
                />
                {this.renderCommentSection(content)}
            </React.Fragment>
        );
    };

    renderCommunityContent = (content) => {
        switch (content.type) {
            case 'community-discussion':
                return (
                    <DiscussionComponent
                        description={content.description}
                        hash={content.hash}
                        location="SingleContent"
                        mode="full"
                        title={content.title}
                        url={content.url}
                    />
                );
            case 'community-link':
                return (
                    <EditorialCard
                        comment={content.comment}
                        contentUrl={content.url}
                        description={content.description}
                        embedHtml={content.embedHtml}
                        image={content.image}
                        location="SingleContent"
                        subType={content.subType}
                        targetAction="_blank"
                        title={content.title}
                        url={content.url}
                        isCommunityLink
                    />
                );
            case 'community-photo':
                return (
                    <EditorialCard
                        comment={content.title}
                        contentUrl={content.url}
                        image={content.image}
                        imageCoverage="contain"
                        location="SingleContent"
                        shouldSetMinDimensions
                        subType="photo"
                        url={content.url}
                    />
                );
            default:
                return null;
        }
    };

    renderCommentSection = (content) => {
        const commentSectionCn = constructCn(
            'comment-section',
            this.getShowUnifiedPostCard(content) && 'border-padding'
        );

        return (
            <div className={commentSectionCn}>
                <div className="totalCommentCountDisplay">
                    {content.commentCount
                        ? `${content.commentCount} Comment${
                              content.commentCount === 1 ? '' : 's'
                          }`
                        : 'No Comments Yet'}
                </div>
                {renderComments(
                    content,
                    this.setComment,
                    this.props.hideReactionBar
                )}
                <div
                    id={`${content.type}-bottom-comment-input`}
                    className="commentInputDiv"
                >
                    <CommentInput
                        key={content.hash}
                        parentHash={content.hash}
                        onSubmit={(hash, comment, isAnon) => {
                            this.props.submitComment(hash, comment, isAnon);
                        }}
                    />
                </div>
            </div>
        );
    };

    setComment = (comment) => {
        const commentToShow =
            comment &&
            comment.parentHash &&
            this.props.refs[comment.parentHash];
        this.setState(
            {
                commentToShow,
            },
            this.scrollTop
        );
    };

    scrollTop = () => {
        if (window) {
            window.scroll({ top: 0, behavior: 'smooth' });
            if (
                window.history.pushState &&
                this.state.commentToShow &&
                this.state.commentToShow.hash
            ) {
                const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${this.state.commentToShow.hash}`;
                window.history.pushState({ path: newurl }, '', newurl);
            } else {
                const originalURl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
                window.history.pushState(
                    { path: originalURl },
                    '',
                    originalURl
                );
            }
        }
    };

    BackToPrevCommentFunction = () => {
        const prevCommentLevel = getPrevLevelComment(
            this.props.refs,
            this.state.commentToShow.hash
        );
        this.setState(
            {
                commentToShow:
                    prevCommentLevel && this.props.refs[prevCommentLevel],
            },
            this.scrollTop
        );
    };

    render() {
        const content = this.context.getContent(this.props.content.hash);

        const hasUpbStyling = this.getShowUnifiedPostCard(content);

        const postCardShellStyle = constructCn(
            !this.state.commentToShow && 'no-padding',
            hasUpbStyling && 'unified-post-styling'
        );

        const contentIsDeleted = !!(
            content.moderationOption &&
            content.moderationOption.status &&
            content.moderationOption.status.type === 'delete'
        );
        const ContentToDisplay = contentIsDeleted ? (
            <DeletedPost />
        ) : (
            this.renderMainContent(content)
        );
        return (
            <CommonCardShell className={postCardShellStyle}>
                <div className="component-Community-SingleCommunityContentSection">
                    {ContentToDisplay}
                </div>
            </CommonCardShell>
        );
    }
}

export default SingleCommunityContentSection;

SingleCommunityContentSection.contextType = CommunityContext;

SingleCommunityContentSection.propTypes = {
    PAGE_PROPS,
    /**
     * serialized content object
     */
    content: PropTypes.shape({
        author: PropTypes.shape({
            userId: PropTypes.number.isRequired,
            username: PropTypes.string.isRequired,
            hash: PropTypes.string.isRequired,
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
            }).isRequired,
            userCommunityData: PropTypes.shape({
                id: PropTypes.number,
                connectionCount: PropTypes.number,
                followerCount: PropTypes.number,
                isVip: PropTypes.number,
            }).isRequired,
            connectWithMeText: PropTypes.string,
            credential: PropTypes.string,
        }),
        canComment: PropTypes.bool.isRequired,
        category: PropTypes.string,
        commentCount: PropTypes.number,
        contentDate: PropTypes.string,
        comments: PropTypes.arrayOf(PropTypes.object).isRequired,
        group: PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            groupUrl: PropTypes.string.isRequired,
            hash: PropTypes.string.isRequired,
            logo: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            privacySetting: PropTypes.string.isRequired,
        }),
        moderationOption: PropTypes.shape({
            status: PropTypes.string,
            editableFields: PropTypes.arrayOf(PropTypes.string).isRequired,
        }).isRequired,
        reactionBar: PropTypes.shape({
            commenting: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            liking: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            flagging: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
            sharing: PropTypes.shape({
                active: PropTypes.bool.isRequired,
                enabled: PropTypes.bool.isRequired,
                icon: PropTypes.string,
                label: PropTypes.string,
                showCount: PropTypes.bool,
            }),
        }).isRequired,
        time: PropTypes.string.isRequired,
        title: PropTypes.string,
        description: PropTypes.string,
        rawHTML: PropTypes.string,
        hash: PropTypes.string.isRequired,
        contentUrl: PropTypes.string.isRequired,
        topic: PropTypes.shape({
            id: PropTypes.number.isRequired,
            isActive: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
        location: PropTypes.string,
    }),
    /**
     * bool to hide reaction bar
     */
    hideReactionBar: PropTypes.bool,
    isPreview: PropTypes.bool,
    refs: PropTypes.objectOf(
        PropTypes.shape({
            author: PropTypes.shape({
                userId: PropTypes.number.isRequired,
                username: PropTypes.string.isRequired,
                hash: PropTypes.string.isRequired,
                image: PropTypes.shape({
                    src: PropTypes.string.isRequired,
                    alt: PropTypes.string.isRequired,
                }).isRequired,
                connectWithMeText: PropTypes.string,
                credential: PropTypes.string,
                interests: PropTypes.arrayOf(PropTypes.string),
                isCommunityManager: PropTypes.bool,
                isHighlightedUser: PropTypes.bool,
                karmaScore: PropTypes.string,
                location: PropTypes.string,
                name: PropTypes.string,
                publicUrl: PropTypes.string,
                relation: PropTypes.shape({
                    isFollowing: PropTypes.bool,
                    connectionStatus: PropTypes.string,
                }),
                userCommunityData: PropTypes.shape({
                    connectionCount: PropTypes.number,
                    followerCount: PropTypes.number,
                    id: PropTypes.number,
                    isVip: PropTypes.number,
                }),
            }),
            comment: PropTypes.string,
            commentCount: PropTypes.number,
            comments: PropTypes.arrayOf(PropTypes.object),
            contentDate: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.instanceOf(Date),
            ]),
            deletable: PropTypes.bool,
            editable: PropTypes.bool,
            getTotalCount: PropTypes.func,
            hash: PropTypes.string,
            isAnon: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
            isNew: PropTypes.bool,
            likes: PropTypes.number,
            moderationOption: PropTypes.shape({
                editableFields: PropTypes.arrayOf(PropTypes.string),
                status: PropTypes.string,
            }),
            contentType: PropTypes.string,
            type: PropTypes.string,
            parentHash: PropTypes.string,
            parentType: PropTypes.string,
        })
    ),
    getContent: PropTypes.func,
    submitComment: PropTypes.func,
    currentTopic: PropTypes.shape({
        id: PropTypes.number,
        isDefault: PropTypes.number,
        layout: PropTypes.string,
        qaDataAttr: PropTypes.string,
        sponsored: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }),
        title: PropTypes.string,
        total: PropTypes.number,
        url: PropTypes.string,
    }),
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            isDefault: PropTypes.number,
            layout: PropTypes.string,
            qaDataAttr: PropTypes.string,
            title: PropTypes.string,
            total: PropTypes.number,
            url: PropTypes.string,
        })
    ),
};

SingleCommunityContentSection.defaultProps = {
    refs: {},
    isPreview: false,
    hideReactionBar: false,
    topics: [],
    content: {},
    getContent: () => {},
    submitComment: () => {},
    currentTopic: {},
    PAGE_PROPS: {},
};
